<template>
  <v-app id="login">
    <div class="logo">
      <img src="@/assets/images/logo.png" />
      <!-- <h2>Backoffice</h2> -->
    </div>
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-5 login-card">
              <v-card-text>
                <v-form>
                  <v-text-field
                    label="Login"
                    name="login"
                    prepend-icon="person"
                    type="text"
                    v-model="userData.username"
                  ></v-text-field>

                  <v-text-field
                    id="password"
                    label="Password"
                    name="password"
                    prepend-icon="lock"
                    type="password"
                    v-model="userData.password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <p>{{ loginMsg }}</p>
                <v-spacer></v-spacer>
                <v-btn depressed fab dark x-large @click="login()"
                  >Entrar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  export default {
    name: "login",
    props: {
      source: String,
    },
    data: () => ({
      userData: {
        username: "",
        password: "",
      },
      loginMsg: "",
      apiCallResult: {},
    }),
    methods: {
      async login() {
        this.loginMsg = "A validar...";
        if (this.userData.username == "" || this.userData.password == "") {
          this.loginMsg = "Introduza o seu username e password";
        } else {
          await this.$store.dispatch("logUserIn", this);

          if (
            this.userData.username == "EU_user" &&
            this.userData.password == "EUNF7wa4"
          ) {
            this.loginMsg = "Bem-vindo!";
            window.sessionStorage.setItem("loggedIn", true);
            this.$router.push("/");
          } else {
            this.loginMsg = "Dados incorretos";
          }
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  #login {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 900;
    background: linear-gradient(90deg, #6edc87 3.51%, #776cf6 100%) !important;
    .logo {
      position: absolute;
      top: 40px;
      left: 40px;
      width: 300px;
      img {
        width: 150px;
        margin-bottom: 20px;
        display: block;
      }
      h2 {
        text-align: left;
        font-family: "Montserrat", sans-serif;
        color: white;
        padding-top: 5px;
        border-top: 6px solid white;
        display: inline-block;
        font-weight: 500;
      }
    }
    .login-card {
      padding: 30px;
      border-radius: 0;
      border-top-right-radius: 200px;
      border-bottom-right-radius: 200px;
      padding-right: 150px;
      button {
        font-family: "Montserrat", sans-serif;
        letter-spacing: 0ch;
        font-size: 12px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 40px;
        background: linear-gradient(
          90deg,
          #6edc87 3.51%,
          #776cf6 100%
        ) !important;
      }
    }
  }
</style>
